export const FooterLinks = [
  {
    title: "Study Abroad",
    footLinks: [
      { title: "USA", href: "/study-abroad/usa" },
      { title: "UK", href: "/study-abroad/uk" },
      { title: "Canada", href: "/study-abroad/canada" },
      { title: "Australia", href: "/study-abroad/australia" },
      { title: "Europe", href: "/study-abroad/europe" },
      { title: "New Zealand", href: "/study-abroad/new-zealand" },
    ],
  },
  {
    title: "Our Services",
    footLinks: [
      { title: "Career Counselling", href: "/services/career-counselling" },
      { title: "Test Preparation", href: "/services/test-preparation" },
      { title: "Application Process", href: "/services/application-process" },
      { title: "Loan Assistance", href: "/services/loan-assistance" },
      { title: "Mock Interviews", href: "/services/mock-interviews" },
      { title: "Visa Guidance", href: "/services/visa-guidance" },
    ],
  },
  {
    title: "Practice Area",
    footLinks: [
      { title: "Home", href: "/" },
      { title: "Study Abroad", href: "/study-abroad" },
      { title: "Test Preps", href: "/test-preps" },
      { title: "About Us", href: "/about-us" },
      { title: "Faq's", href: "/faq" },
    ],
  },
  {
    title: "Test Preps",
    footLinks: [
      { title: "IELTS", href: "/ielts" },
      { title: "PTE", href: "/pte" },
      { title: "TOEFL", href: "/tofel" },
    ],
  },
];
